import { render, staticRenderFns } from "./commonTerms.vue?vue&type=template&id=8580f182"
import script from "./commonTerms.vue?vue&type=script&lang=js"
export * from "./commonTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports